export var SLACK_CHANNEL = /* @__PURE__ */ ((SLACK_CHANNEL2) => {
  SLACK_CHANNEL2["CAMPAIGN_ALERTS"] = "C04PMBE0V0B";
  SLACK_CHANNEL2["ENG_ERROR_ALERTS"] = "C05FP13245C";
  SLACK_CHANNEL2["ENG_TICKET_ALERTS"] = "C08MRG8LULX";
  SLACK_CHANNEL2["ONBOARDING_ALERTS"] = "C07C1F6N9L2";
  SLACK_CHANNEL2["ENG_SERVICE_ALERTS"] = "C073UBST1UK";
  SLACK_CHANNEL2["SUCCESS_ALERTS"] = "C05TUNSKFGB";
  SLACK_CHANNEL2["TELNYX_SUPPORT"] = "C04RF0HLJTF";
  SLACK_CHANNEL2["CONVO_ALERTS"] = "C06DS01JLAW";
  SLACK_CHANNEL2["AI_FAQ_MESSAGES"] = "C084FRQ96R5";
  SLACK_CHANNEL2["AI_FAQ_MESSAGES_SENT"] = "C08AXAE9XNX";
  SLACK_CHANNEL2["GLOBAL_INTENT_ALERTS"] = "C08B2F5LPNV";
  SLACK_CHANNEL2["TEST"] = "C059CMACJQJ";
  SLACK_CHANNEL2["TIM_TESTING"] = "C05MDN606TW";
  SLACK_CHANNEL2["AUTOMATION_ALERTS"] = "C08KEK1P79N";
  SLACK_CHANNEL2["CUSTOMER_FEEDBACK_ALERTS"] = "C08LF0C8F0U";
  SLACK_CHANNEL2["AGENT_FEEDBACK_ALERTS"] = "C08MFNU1A4V";
  SLACK_CHANNEL2["AGENT_MESSAGE_ALERTS"] = "C08N934H1AA";
  return SLACK_CHANNEL2;
})(SLACK_CHANNEL || {});
export var SLACK_GROUP_IDS = /* @__PURE__ */ ((SLACK_GROUP_IDS2) => {
  SLACK_GROUP_IDS2["ENG"] = "S04SG4NUYR0";
  SLACK_GROUP_IDS2["SUCCESS"] = "S04SJJERVA8";
  return SLACK_GROUP_IDS2;
})(SLACK_GROUP_IDS || {});
export const ONETEXT_SLACK_WORKSPACE_NAME = "onetextworkspace";
export var SLACK_USER_GROUPS = /* @__PURE__ */ ((SLACK_USER_GROUPS2) => {
  SLACK_USER_GROUPS2["ENG"] = "@eng";
  SLACK_USER_GROUPS2["CHAMPIONS"] = "@champions";
  SLACK_USER_GROUPS2["CLOSERS"] = "@closers";
  SLACK_USER_GROUPS2["FOUNDERS"] = "@founders";
  SLACK_USER_GROUPS2["AGENTS"] = "@agents";
  SLACK_USER_GROUPS2["HERE"] = "@here";
  SLACK_USER_GROUPS2["EVERYONE"] = "@everyone";
  return SLACK_USER_GROUPS2;
})(SLACK_USER_GROUPS || {});
